import Carousel from 'react-bootstrap/Carousel';
import l1 from '../living/l1.jpg';
import l2 from '../living/l2.jpg';
import l3 from '../living/l3.jpg';
import l4 from '../living/l4.jpg';
import l5 from '../living/l5.jpg';
import l6 from '../living/l6.jpg';
import l7 from '../living/l7.jpg';
import l8 from '../living/l8.jpg';

import l10 from '../living/l10.jpg';
import l11 from '../living/l11.jpg';
import l12 from '../living/l12.jpg';
import l13 from '../living/l13.jpg';
import l14 from '../living/l14.jpg';
import l16 from '../living/l16.jpg';
import l17 from '../living/l17.jpg';
import l18 from '../W51/W51Living.jpg';
import l19 from '../W51/W51Living2.jpg';
import l20 from '../W51/W51Living3.jpg';




function LivingCarousel() {
    return (
        <Carousel fade>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l18}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l19}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l20}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l17}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l16}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l11}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l13}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l14}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l10}
                    alt="First slide"
                />
             
            </Carousel.Item>
          
         
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l1}
                    alt="First slide"
                />
             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l2}
                    alt="Second slide"
                />

             
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l3}
                    alt="Third slide"
                />

                
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l4}
                    alt="Third slide"
                />       
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l5}
                    alt="Third slide"
                />       
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l6}
                    alt="Third slide"
                />       
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l7}
                    alt="Third slide"
                />       
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={l8}
                    alt="Third slide"
                />       
            </Carousel.Item>
        </Carousel>


    );
}

export default LivingCarousel;